import { Component, OnInit, ElementRef, HostListener, ViewChild, Input } from '@angular/core';
import { BackgroundVideoService } from 'src/app/services/BackgroundVideo/background-video.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { gsap, Expo, Quad } from 'gsap';

@Component({
    selector: 'app-video-play-pause-button',
    templateUrl: './video-play-pause-button.component.html',
    styleUrls: ['./video-play-pause-button.component.scss']
})
export class VideoPlayPauseButtonComponent implements OnInit {

    @ViewChild('wrapper', { static: true }) public wrapper: ElementRef | undefined;
    @ViewChild('iconPlay', { static: true }) public iconPlay: ElementRef | undefined;
    @ViewChild('iconPause', { static: true }) public iconPause: ElementRef | undefined;

    @Input() data: any | undefined;
    @Input() type: string | undefined;
    isPlaying: boolean = false
    isMobile: boolean = false
    isRollover: boolean = true

    image: string
    // imageOver: string

    // public data;

    constructor(
        public breakpointObserver: BreakpointObserver,
        public bgVideoService: BackgroundVideoService
    ) { 

        breakpointObserver.observe([
            Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            this.isMobile = result.matches ? true : false;
        });

        // this.image = 'assets/img/icons/play-icon-thin.png'
        this.image = 'assets/img/icons/play-v3.png'
        // this.imageOver = 'assets/img/icons/play-icon-thin-rollover.png'

    }

    ngOnInit(): void {
        setTimeout(() => {
            this.onOut()
        }, 3000);


    }

    ngAfterViewInit() {


        this.bgVideoService.isPlaying$.subscribe(val => {
            let vid = this.data?.nativeElement;
            if (vid == undefined) {
                vid = this.data
            }

            if (val) {
                this.image = 'assets/img/icons/pause-v3.png'
                // this.imageOver = 'assets/img/icons/pause-icon-thin-rollover.png'

                // gsap.set(this.iconPlay?.nativeElement, { autoAlpha: 0 });
                // gsap.set(this.iconPause?.nativeElement, { autoAlpha: 1 });
                // gsap.to(vid, 1.2, { autoAlpha: 1, ease: Quad.easeOut })

                try {
                    vid.play()
                }
                catch (e) { }
            }
            else {
                this.image = 'assets/img/icons/play-v3.png'
                // this.imageOver = 'assets/img/icons/play-icon-thin-rollover.png'

                // gsap.set(this.iconPlay?.nativeElement, { autoAlpha: 1 });
                // gsap.set(this.iconPause?.nativeElement, { autoAlpha: 0 });
                // gsap.to(vid, 1.2, { autoAlpha: 0, ease: Quad.easeOut })

                try {
                    vid.pause()
                }
                catch (e) { }
            }
        })
    }

    onClick(): void {
        // let vid = this.data?.nativeElement;
        // if (vid == undefined) {
        //     vid = this.data
        // }
        // // this.audio.playSfx('sfx12');
        // // this.backgroundVideoService.togglePlay();

        // gsap.set(this.iconPlay?.nativeElement, { autoAlpha: vid.paused ? 0 : 1 });
        // gsap.set(this.iconPause?.nativeElement, { autoAlpha: vid.paused ? 1 : 0 });

        // !vid.paused ? vid.pause() : vid.play();

        // this.isPlaying = !this.isPlaying;

        this.bgVideoService.togglePlay()
    }

    onOver() {
        if (this.isMobile) return;
        this.isRollover = true
    }

    onOut() {
        // if(this.isMobile) return;
        this.isRollover = false
    }

    @HostListener('window:blur')
    onBlur() {
        let vid = this.data?.nativeElement;
        if (vid == undefined) {
            vid = this.data
        }

        if (vid) {
            vid.pause();
        }
    }

    @HostListener('window:focus')
    onFocus() {
        let vid = this.data?.nativeElement;
        if (vid == undefined) {
            vid = this.data
        }

        if (vid && this.bgVideoService.isPlaying) {
            vid.play();
        }
        
    }
}
